import { baseApi } from '@/store/api/base.api';
import { CaseStudyResponse } from '@/types/case-study';
import { getQueryString } from '@/utils';

export const proudApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getProuds: builder.query<
			CaseStudyResponse,
			{
				page?: number;
				pageSize?: number;
			}
		>({
			query: (params = {}) => {
				const { page = 1, pageSize = 10 } = params;
				return {
					url:
						'/case-studies?' +
						getQueryString({
							pagination: {
								pageSize,
								page,
							},
							populate: 'image',
						}),
					method: 'GET',
				};
			},
		}),

		getProudBySlug: builder.query<any, { slug: string; query: string }>({
			query: ({ slug, query }) => ({
				url: `/case-studies/${slug}?${query}`,
				method: 'GET',
			}),
		}),
	}),
	overrideExisting: true,
});

export const { useGetProudsQuery, useGetProudBySlugQuery } = proudApi;
